import isFuture from 'date-fns/is_future';
import isPast from 'date-fns/is_past';
import toDate from './toDate';

/**
 * Function to validate if an event is live, past or future given a start and end date
 * You can provide the date object itself or a date string (FULL_FORMAT)
 */
const getLiveState = (
  startDate?: Date | string | null,
  endDate?: Date | string | null,
): 'past' | 'live' | 'future' => {
  const start =
    typeof startDate === 'string' ? (toDate(startDate) as Date) : startDate;
  const end = typeof endDate === 'string' ? (toDate(endDate) as Date) : endDate;

  if (end && isPast(end)) {
    return 'past';
  }
  if (start && isPast(start) && (!end || isFuture(end))) {
    return 'live';
  }
  return 'future';
};

export default getLiveState;
